import { HiMenuAlt3, HiX } from "react-icons/hi";
import { menuItems, personalInformation } from "../helper/constant";

const Sidebar = ({ activeTab, onTabChange, isOpen, setIsOpen }) => {
  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-6 right-6 z-[60] p-3 bg-emerald-500 text-black rounded-full"
      >
        {isOpen ? <HiX size={24} /> : <HiMenuAlt3 size={24} />}
      </button>

      <aside
        className={`
        fixed inset-y-0 left-0 z-50 w-72 bg-neutral-900 border-r border-neutral-800 transform transition-transform duration-300
        ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:static
      `}
      >
        <div className="flex flex-col h-full p-8">
          <div className="mb-12">
            <h1 className="text-2xl font-bold text-white tracking-tighter">
              {personalInformation.name}
            </h1>
            <p className="text-emerald-500 text-[10px] font-mono mt-1 uppercase tracking-widest">
              {personalInformation.role}
            </p>
          </div>

          <nav className="flex-1 space-y-2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={`w-full flex items-center gap-4 px-5 py-3 rounded-xl text-sm transition-all ${
                  activeTab === item.id
                    ? "bg-emerald-500 text-black font-bold shadow-lg shadow-emerald-500/20"
                    : "text-neutral-400 hover:bg-neutral-800 hover:text-white"
                }`}
              >
                {item.icon} {item.label}
              </button>
            ))}
          </nav>

          <div className="pt-6 border-t border-neutral-800">
            <div className="flex flex-col gap-1">
              <p className="text-[9px] text-neutral-500 uppercase tracking-[0.2em]">
                © {new Date().getFullYear()} {personalInformation.name}
              </p>
              <p className="text-[8px] text-neutral-600 uppercase tracking-[0.1em]">
                All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </aside>

      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
        />
      )}
    </>
  );
};

export default Sidebar;
